<template>
  <div class="my_title m-lr-11">
    <span
      class="title"
      :style="`flex: 0 0 ${!Number.isNaN(Number(titleWidth)) ? titleWidth + 'px' : titleWidth}`"
    >{{ title }}</span>
    <el-input
      class="my_title_input"
      v-model="text"
      :disabled="display"
      size="small"
      :maxlength="50"
    ></el-input>
    <el-checkbox
      v-if="btnShow"
      v-model="display"
      @change="change_checkbox"
    >{{$t('view_back_top_index_105')}}</el-checkbox>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'my_title',
  props: {
    title: {
      type: String,
      default: i18n.t('widgets_basic_article_info_edit_342')
    },
    titleWidth: {
      type: String,
      default: '40'
    },
    inputValue: {
      type: String,
      default: ''
    },
    checkboxValue: {
      type: Boolean,
      default: true
    },
    btnShow:{
      type: Boolean,
      default:true
    }
  },
  watch: {
    text (val) {
      this.$emit('update:inputValue', val)  // 双向数据绑定
    },
    display (val) {
      this.$emit('update:checkboxValue', val)
    },
    inputValue (val) {
      this.text = val
    },
    checkboxValue (val) {
      this.display = val
    }
  },
  data () {
    return {
      text: this.inputValue,
      display: this.checkboxValue
    }
  },
  methods: {
    change_checkbox (val) {
      this.$emit('change_checkbox', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.my_title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  .title {
    display: inline-block;
    font-size: 13px;
    text-align: right;
    overflow: hidden;
    height: 32px;
    line-height: 32px;
  }
  .my_title_input {
    margin-right: 8px;
    margin-left: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_title/Index.vue